import React from 'react';
import { ICON_STROKE } from '../../constants/icon-stroke';

/** Coupon — price tag with punch hole (20×20 viewBox). Matches admin `PromoIcon` in `ReservationModal/icons.tsx`. */

const COUPON_TAG_PATH_D =
  'M6.66669 6.66663H6.67502M1.66669 4.33329L1.66669 8.06205C1.66669 8.46971 1.66669 8.67353 1.71274 8.86534C1.75356 9.03541 1.82091 9.19798 1.91229 9.3471C2.01536 9.51529 2.15948 9.65942 2.44773 9.94767L8.83826 16.3382C9.8283 17.3282 10.3233 17.8233 10.8941 18.0087C11.3963 18.1719 11.9371 18.1719 12.4392 18.0087C13.01 17.8233 13.5051 17.3282 14.4951 16.3382L16.3383 14.4951C17.3283 13.505 17.8233 13.01 18.0088 12.4392C18.1719 11.9371 18.1719 11.3962 18.0088 10.8941C17.8233 10.3233 17.3283 9.82824 16.3383 8.8382L9.94773 2.44767C9.65948 2.15942 9.51535 2.0153 9.34716 1.91223C9.19804 1.82084 9.03547 1.7535 8.8654 1.71268C8.67359 1.66663 8.46977 1.66663 8.06212 1.66663L4.33335 1.66663C3.39993 1.66663 2.93322 1.66663 2.5767 1.84828C2.2631 2.00807 2.00813 2.26304 1.84834 2.57664C1.66669 2.93316 1.66669 3.39987 1.66669 4.33329ZM7.08335 6.66663C7.08335 6.89674 6.89681 7.08329 6.66669 7.08329C6.43657 7.08329 6.25002 6.89674 6.25002 6.66663C6.25002 6.43651 6.43657 6.24996 6.66669 6.24996C6.89681 6.24996 7.08335 6.43651 7.08335 6.66663Z';

export interface CouponTagIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

export const CouponTagIcon: React.FC<CouponTagIconProps> = ({
  size = 20,
  color = 'currentColor',
  strokeWidth = ICON_STROKE.standard,
  className,
  style,
  title,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    style={style}
    role={title ? 'img' : 'presentation'}
    aria-hidden={title ? undefined : true}
  >
    {title ? <title>{title}</title> : null}
    <path
      d={COUPON_TAG_PATH_D}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
